import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';

declare function notify(): any;

declare var $: any;

@Component({
    selector: 'app-question-interstitial-screen-variation-two',
    templateUrl: './question-interstitial-screen-variation-two.component.html',
    styleUrls: ['./question-interstitial-screen-variation-two.component.scss'],
    standalone: false
})
export class QuestionInterstitialScreenVariationTwoComponent implements OnInit {

  @Input() class_name = '';
  @Input() session_details: any;
  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter();

  options: any[] = [];
  notify: any;
  checked = false;

  constructor() {
    this.notify = notify();
  }

  ngOnInit(): void {
    this.sendResponse();
  }

  onChange(): void {
    const $button = $('#next-question');
    if (this.checked) {
      $button.text('Next');
      this.notify.init({
        message: '<strong>You will be reminded to complete this at a later stage.</strong>', // required
        icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
        size: 'lg',     // default: null; options: 'lg'
        style: 'info',  // default: null; options: 'info', 'success',
        close: true,    // default: false (close button enabled, auto-close duration removed)
        speed: 350,     // default: 350 (fade in/out speed)
        duration: 5000  // default: 5000 (duration active)
      });
    } else {
      $button.text('Add Details');
    }
    this.sendResponse();
  }

  sendResponse(): void {
    let answer = 'skipped';
    if (!this.checked) {
      answer = 'Adding Details';
    }
    this.question.answer = answer;
    this.questionAnswer.emit(this.question);
  }

}
